import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import { useOrganisation } from '@/lib/OrganisationContext';

export default function Suspended() {
  const { logout } = useAuth();
  const { organisations, selectOrganisation, reloadOrganisations } = useOrganisation();
  const navigate = useNavigate();
  const active = organisations.filter((org) => (org.status || 'active') === 'active');
  return (
    <section className="mx-auto max-w-xl rounded-lg border border-amber-700 bg-[#1a1a1a] p-6 text-center sm:p-8" aria-labelledby="suspended-title">
      <h1 id="suspended-title" className="text-2xl font-semibold text-white">Organisation access is suspended</h1>
      <p className="mt-4 text-white/80">Your organisation access is temporarily unavailable. Please contact Diverse Integration for help.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        {active.map((org) => (
          <button key={org.id} type="button" className="min-h-11 w-full min-w-0 max-w-full break-words rounded bg-[#FFB800] px-4 py-2 text-sm font-medium text-[#111111] hover:bg-amber-400 sm:w-auto" onClick={() => { selectOrganisation(org.id); navigate('/'); }}>
            Continue to {org.name}
          </button>
        ))}
        <button type="button" className="min-h-11 rounded border border-gray-600 px-4 py-2 text-sm text-white/80 hover:bg-white/10" onClick={() => reloadOrganisations().catch(() => {})}>Try again</button>
        <button type="button" className="min-h-11 rounded border border-gray-600 px-4 py-2 text-sm text-white/80 hover:bg-white/10" onClick={() => logout()}>Sign out</button>
      </div>
    </section>
  );
}
